import { CalendarCheck, Check, Flame, Target } from "lucide-react";
import { currentDayStreak, dailyFor, questDone, questsForDay, questValue } from "../../engine";
import { useGame } from "../../state/GameProvider";

/** 今日修業 — three daily quests plus the 連續修業 day streak. Everything is
 * derived from local progress, so the panel updates with every answer. */
export function QuestPanel() {
  const { state } = useGame();
  const daily = dailyFor(state.progress);
  const quests = questsForDay(daily.dayKey);
  const streak = currentDayStreak(state.progress);
  const allDone = quests.every((quest) => questDone(daily, quest));

  return (
    <section className={`panel quest-panel${allDone ? " all-done" : ""}`}>
      <div className="panel-title">
        <CalendarCheck size={15} />
        今日修業
        <strong className="quest-streak">
          <Flame size={12} />
          <span>{streak > 0 ? `連續 ${streak} 天` : "今日未開張"}</span>
        </strong>
      </div>
      {quests.map((quest) => {
        const value = Math.min(questValue(daily, quest), quest.target);
        const done = value >= quest.target;
        return (
          <div key={quest.id} className={`quest-row${done ? " done" : ""}`}>
            <span className="q-mark">{done ? <Check size={13} /> : <Target size={12} />}</span>
            <span className="q-body">
              <strong>{quest.label}</strong>
              <i className="meter">
                <b style={{ width: `${Math.round((value / quest.target) * 100)}%` }} />
              </i>
            </span>
            <span className="q-val">
              {`${value}/${quest.target}`}
            </span>
          </div>
        );
      })}
      {allDone && <div className="quest-done-note">今日修業已成 · 明日再戰不輟</div>}
    </section>
  );
}
